import { Entity } from "./Entity";

export class CollisionEvent extends Event {
  constructor(
    readonly target: Entity,
    readonly other: Entity,
  ) {
    super("collision");
  }
}
